// extracted by mini-css-extract-plugin
export default {"content":"qfC0ueNxuLiSetLmq9OJWg==","text":"PjMz6LbCB5Ii6LA9FivDNw==","address":"o+djy0O4md2Qke3hv8asWg=="};